import { useNavigate } from 'react-router-dom'

/**
 * "← Back" for the entity screens.
 *
 * The main Kit19 app opens these screens in a new tab (View entity / Edit entity),
 * so there is nothing to go back to: the tab is simply closed. Inside the app the
 * button steps back through history, and falls back to the landing page when the
 * browser refuses to close a tab it did not open.
 */
export function BackButton({ label = '← Back' }: { label?: string }) {
  const navigate = useNavigate()

  const onClick = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }
    window.close()
    window.setTimeout(() => {
      if (!window.closed) navigate('/', { replace: true })
    }, 150)
  }

  return (
    <button type="button" className="btn" onClick={onClick}>
      {label}
    </button>
  )
}
